import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Switch } from '@mui/material';
import { ArrowBackIos } from '@mui/icons-material';
import { toast } from 'react-toastify';
import { useGetTrimLightsDeviceByLocationMutation } from '../../../../services/trimLights/trimLightsService';
import Strings from '../../../../i18n';
import { Header } from '../../../../components/header/header';
import { ButtonIconStyled } from '../../../../views/devices/devicesStyles';
import {
  StyledHeaderContainer,
  StyledTitleHeader
} from '../../../../components/layout/main/mainStyles';
import './xSeriesSetup.css';
import { PRODUCTS } from '../../../../constants/ProductsLight';
import {
  useCalculateLengthProductMutation,
  useSendOnOffCommandMutation,
  useSetChannelOffsetMutation,
  useSetEnableOrDisableMutation,
  useSetProductLenghtMutation,
  useSetProductTypeMutation,
  useSetToogleDirectionMutation
} from '../../../../services/commandsService/commandsService';
import { ICommandOnOff } from '../../../../types/commandsInterface';
import { SelectProductModal } from '../../../../components/groups/selectProductModal';
import OffsetModal from '../../../../components/groups/offsetModal';
import SizeModal from '../../../../components/groups/sizeModal';
import SetupModal from '../../../../components/groups/setupModal';
import SetupColorModal from '../../../../components/groups/setupColorModal';

interface ProductTypeData {
  name: string;
  idChannel: number;
  lightId: number;
  deviceId: string;
}

export const XSeriesSetupView = () => {
  const navigate = useNavigate();
  const { locationId } = useParams();
  const [showProductModal, setShowProductModal] = useState<boolean>(false);
  const [productTypeData, setProductTypeData] =
    useState<ProductTypeData | null>(null);
  const [offsetData, setOffsetData] = useState<{
    isOpen: boolean;
    offset: string;
    lightId: number;
    deviceId: string;
  } | null>(null);
  const [sizeData, setSizeData] = useState<{
    isOpen: boolean;
    productLength: string;
    id: number;
  } | null>(null);
  const [isVisibleSetUpModal, setIsVisibleSetUpModal] = useState(false);
  const [isVisibleSetUpColorModal, setIsVisibleSetUpColorModal] = useState<{
    isOpen: boolean;
    deviceId: string;
    lightId: number;
  } | null>(null);

  const [getTrimLightsDeviceByLocation, { data: trimLights }] =
    useGetTrimLightsDeviceByLocationMutation();

  const [setSwitch, { isSuccess: isSuccessSetSwitch }] =
    useSendOnOffCommandMutation();

  const [setProductType, { isSuccess: isSuccessSetProductType }] =
    useSetProductTypeMutation();

  const [setEnableOrDisable] = useSetEnableOrDisableMutation();
  const [setToogleDirection, { isSuccess: isSuccessSetDirection }] =
    useSetToogleDirectionMutation();
  const [setChannelOffset, { isSuccess: isSuccessSetOffset }] =
    useSetChannelOffsetMutation();
  const [setProductLenght, { isSuccess: isSuccessSetProductLenght }] =
    useSetProductLenghtMutation();
  const [
    calculateLengthProduct,
    { isSuccess: isSucessCalculateLengthProduct }
  ] = useCalculateLengthProductMutation();

  useEffect(() => {
    if (locationId) {
      getTrimLightsDeviceByLocation(+locationId);
    }
  }, [locationId, getTrimLightsDeviceByLocation]);
  const handleTest = () => {};

  const findProduct = (productId: number) => {
    const productData = PRODUCTS.find((product) => product.id === productId);
    if (productData) {
      return productData.name;
    }
    return '';
  };

  const isNotHaveProduct = (productId: number) => {
    const productData = PRODUCTS.find((product) => product.id === productId);
    if (productData) {
      return productData.name === PRODUCTS[0].name;
    }
    return true;
  };

  const sendSwitchCommand = (payload: ICommandOnOff) => {
    setSwitch(payload);
  };

  useEffect(() => {
    if (isSuccessSetSwitch && locationId) {
      toast.success(Strings.commands.commandSentSuccessfully);
      getTrimLightsDeviceByLocation(+locationId);
    }
  }, [isSuccessSetSwitch, locationId]);

  const handleSetProductType = (
    configurationId: number,
    productType: number,
    deviceId: string
  ) => {
    setProductType({ configurationId, productType, deviceId });
  };

  useEffect(() => {
    if (isSuccessSetProductType && locationId) {
      toast.success(Strings.commands.commandSentSuccessfully);
      getTrimLightsDeviceByLocation(+locationId);
    }
  }, [isSuccessSetProductType, locationId]);

  useEffect(() => {
    if (isSuccessSetDirection && locationId) {
      toast.success(Strings.commands.commandSentSuccessfully);
      getTrimLightsDeviceByLocation(+locationId);
    }
  }, [isSuccessSetDirection, locationId]);

  useEffect(() => {
    if (isSuccessSetOffset && locationId) {
      toast.success(Strings.commands.commandSentSuccessfully);
      getTrimLightsDeviceByLocation(+locationId);
    }
  }, [isSuccessSetOffset, locationId]);

  useEffect(() => {
    if (isSuccessSetProductLenght && locationId) {
      toast.success(Strings.commands.commandSentSuccessfully);
      getTrimLightsDeviceByLocation(+locationId);
    }
  }, [isSuccessSetProductLenght, locationId]);

  useEffect(() => {
    if (isSucessCalculateLengthProduct && locationId) {
      toast.success(Strings.commands.commandSentSuccessfully);
      getTrimLightsDeviceByLocation(+locationId);
    }
  }, [isSucessCalculateLengthProduct, locationId]);

  return (
    <>
      <Header>
        <StyledHeaderContainer>
          <div className="row justify-content-between">
            <div className="col-4 text-left">
              <ButtonIconStyled
                size="small"
                onClick={() =>
                  navigate(`/locations/${locationId}/applications/groups`)
                }
              >
                <ArrowBackIos />
              </ButtonIconStyled>
            </div>
            <div className="col-4 text-center">
              <StyledTitleHeader>
                {Strings.groups.xSeriesSetup}
              </StyledTitleHeader>
            </div>
            <div className="col-4" />
          </div>
        </StyledHeaderContainer>
      </Header>
      <div className="channel-list">
        {trimLights?.map((controller: any, index: number) => (
          <div className="channel-row" key={index}>
            {controller.lights.map((light: any, lightIndex: number) => (
              <div className="channel-card" key={lightIndex}>
                <div className="channel-header">
                  <div className="channel-title">
                    <span className="series-name">{controller.deviceId}</span>
                    <h3 className="channel-name">{light.name}</h3>
                  </div>
                  <Switch
                    color="primary"
                    checked={light.channel.enabled}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      const value = event.target.checked;
                      sendSwitchCommand({
                        id: light.id,
                        method: value ? 'On' : 'Off',
                        type: 'Light'
                      });
                      setEnableOrDisable({
                        configurationId: light.channel.id,
                        enabled: value
                      });
                    }}
                  />
                </div>

                <div className="channel-content">
                  <div className="channel-section">
                    <div className="section-label">Product</div>
                    <button
                      type="button"
                      className="section-value"
                      onClick={() => {
                        setProductTypeData({
                          name: light.name,
                          idChannel: light.channel.id,
                          lightId: light.id,
                          deviceId: controller.deviceId
                        });
                        setShowProductModal(true);
                      }}
                    >
                      {findProduct(light.channel.productTypeId || 0)}
                    </button>
                  </div>

                  <div className="channel-section">
                    <div className="section-label">Select Size</div>
                    <button
                      type="button"
                      className="section-value"
                      onClick={() => {
                        setIsVisibleSetUpModal(true);
                        setSizeData({
                          isOpen: false,
                          productLength: light.channel.productLength,
                          id: light.channel.id
                        });
                        setIsVisibleSetUpColorModal({
                          isOpen: false,
                          lightId: light.id,
                          deviceId: controller.deviceId
                        });
                      }}
                      disabled={isNotHaveProduct(
                        light.channel.productTypeId || 0
                      )}
                    >
                      {light.channel.productLength || `0'`}
                    </button>
                  </div>

                  <div className="channel-section">
                    <div className="section-label">Direction</div>
                    <button
                      type="button"
                      className="section-value"
                      disabled={isNotHaveProduct(
                        light.channel.productTypeId || 0
                      )}
                      onClick={() => {
                        setToogleDirection({
                          lightId: light.id,
                          isReverse: !light.channel.isReverse,
                          deviceId: controller.deviceId
                        });
                      }}
                    >
                      {light.channel.isReverse ? 'Reverse' : 'Forward'}
                    </button>
                  </div>

                  <div className="channel-section">
                    <div className="section-label">Offset</div>
                    <button
                      type="button"
                      className="section-value"
                      disabled={isNotHaveProduct(
                        light.channel.productTypeId || 0
                      )}
                      onClick={() => {
                        setOffsetData({
                          isOpen: true,
                          offset: light.channel.channelOffset,
                          lightId: light.id,
                          deviceId: controller.deviceId
                        });
                      }}
                    >
                      {light.channel.channelOffset || `0'`}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
      {productTypeData && (
        <SelectProductModal
          show={showProductModal}
          onHide={() => {
            setProductTypeData(null);
            setShowProductModal(false);
          }}
          name={productTypeData.name}
          idChannel={productTypeData.idChannel}
          lightId={productTypeData.lightId}
          deviceId={productTypeData.deviceId}
          sendCommand={sendSwitchCommand}
          handleSetProductType={handleSetProductType}
        />
      )}
      {offsetData && (
        <OffsetModal
          visible={offsetData.isOpen}
          onDismiss={() => {
            setOffsetData(null);
          }}
          onAccept={(offset) => {
            setChannelOffset({
              lightId: offsetData.lightId,
              offsetInches: parseInt(offset, 10),
              deviceId: offsetData.deviceId
            });
          }}
          previousValue={0}
          offset={offsetData.offset}
        />
      )}
      <SetupModal
        visible={isVisibleSetUpModal}
        onDismiss={() => setIsVisibleSetUpModal(false)}
        onAccept={() => {
          setIsVisibleSetUpModal(false);
          setTimeout(() => {
            setIsVisibleSetUpColorModal((tmpIsVisibleSetUpColorModal) => {
              if (!tmpIsVisibleSetUpColorModal) {
                return {
                  isOpen: true,
                  deviceId: 'defaultDeviceId',
                  lightId: 0
                };
              }
              return {
                ...tmpIsVisibleSetUpColorModal,
                isOpen: true
              };
            });
          }, 500);
        }}
        onEnterLength={() => {
          setIsVisibleSetUpModal(false);
          setTimeout(() => {
            setSizeData((tmpSizeData) => {
              if (!tmpSizeData) {
                return { isOpen: true, productLength: '0', id: 0 };
              }
              return {
                ...tmpSizeData,
                isOpen: true,
                productLength: tmpSizeData.productLength || '0',
                id: tmpSizeData.id || 0
              };
            });
          }, 500);
        }}
      />
      {sizeData && (
        <SizeModal
          visible={sizeData.isOpen}
          onDismiss={() => setSizeData(null)}
          onAccept={(productLenght) => {
            setProductLenght({
              id: sizeData.id,
              productLength: parseInt(productLenght, 10)
            });
          }}
          size={sizeData.productLength}
        />
      )}
      <SetupColorModal
        open={isVisibleSetUpColorModal?.isOpen || false}
        onClose={() => {
          setIsVisibleSetUpColorModal(null);
        }}
        onSubmit={(startingOffset, endingOffset) => {
          if (isVisibleSetUpColorModal) {
            calculateLengthProduct({
              deviceId: isVisibleSetUpColorModal.deviceId,
              lightId: isVisibleSetUpColorModal.lightId,
              startingOffset,
              endingOffset
            });
          }
        }}
      />
    </>
  );
};
